// extracted by mini-css-extract-plugin
export default {"xsmall":"320px","small":"448px","medium":"834px","large":"1024px","xlarge":"1200px","xxlarge":"1600px"};